export var SortingTypeIndex;
(function (SortingTypeIndex) {
    SortingTypeIndex[SortingTypeIndex["default"] = 10] = "default";
    // latest = 1,
    SortingTypeIndex[SortingTypeIndex["moderation"] = 1] = "moderation";
    SortingTypeIndex[SortingTypeIndex["popular"] = 2] = "popular";
    SortingTypeIndex[SortingTypeIndex["name"] = 3] = "name";
    SortingTypeIndex[SortingTypeIndex["projects"] = 4] = "projects";
    SortingTypeIndex[SortingTypeIndex["opa"] = 5] = "opa";
    SortingTypeIndex[SortingTypeIndex["score"] = 13] = "score";
})(SortingTypeIndex || (SortingTypeIndex = {}));
export var SortingTypeString = {
    // 1: 'latest',
    1: 'moderation',
    2: 'popular',
    3: 'name',
    4: 'project',
    5: 'opa',
    10: 'default',
    13: 'score'
};
//# sourceMappingURL=sortingType.js.mapexport var SortingTypeIndex;
(function (SortingTypeIndex) {
    SortingTypeIndex[SortingTypeIndex["default"] = 10] = "default";
    // latest = 1,
    SortingTypeIndex[SortingTypeIndex["moderation"] = 1] = "moderation";
    SortingTypeIndex[SortingTypeIndex["popular"] = 2] = "popular";
    SortingTypeIndex[SortingTypeIndex["name"] = 3] = "name";
    SortingTypeIndex[SortingTypeIndex["projects"] = 4] = "projects";
    SortingTypeIndex[SortingTypeIndex["opa"] = 5] = "opa";
    SortingTypeIndex[SortingTypeIndex["score"] = 13] = "score";
})(SortingTypeIndex || (SortingTypeIndex = {}));
export var SortingTypeString = {
    // 1: 'latest',
    1: 'moderation',
    2: 'popular',
    3: 'name',
    4: 'project',
    5: 'opa',
    10: 'default',
    13: 'score'
};
//# sourceMappingURL=sortingType.js.map